import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { SavedTripList } from '../../models/core-apis/saved-search.interfaces';

// eslint-disable-next-line complexity
export const updateBestFareFieldFromSavedSearch = (
  savedSearchData: SavedTripList,
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
) => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (
    !bookWidgetFieldsMasterConfig.bestFareOptionsField?.hide &&
    !bookWidgetFieldsMasterConfig.bestFareOptionsField?.disable &&
    savedSearchData.cabinClassCode
  ) {
    let selectedBestFare = savedSearchData.cabinClassCode;

    const dropdownOptions = [
      ...updatedBookWidgetFields.bestFareOptionsField.dropdownOptions.map(
        (data) => ({
          ...data,
          selected: false
        })
      )
    ];

    const indexOfSelectedBestFare = dropdownOptions.findIndex(
      ({ value }) => value === selectedBestFare
    );

    if (indexOfSelectedBestFare === -1) {
      selectedBestFare = dropdownOptions[0].value;
      dropdownOptions[0].selected = true;
    } else {
      dropdownOptions[indexOfSelectedBestFare].selected = true;
    }

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      bestFareOptionsField: {
        ...updatedBookWidgetFields.bestFareOptionsField,
        selectedBestFare,
        dropdownOptions,
        disable: false,
        hide: false
      }
    };
  }

  return updatedBookWidgetFields;
};
